<template>
    <div class="two">
        <a href="https://weix2.hengdianworld.com/redirect?type=activity&id=315"><img src="../images/cp2.png" class="swiper-img"/></a>
        <Title>
            <template v-slot:index>
                <div class="t1">
                    <span class="index">1</span>
                    留恋忘返的游乐场
                </div>
            </template>
            <template v-slot:xc>
                <div class="t2">
                    亚马快车 喜马天轮 吉祥木马...30余项游乐设施，玩不停！
                </div>
            </template>
        </Title>
        <div class="cover-box">
            <div class="content-box">
                好玩的，有趣的，惊险的，刺激的...！
            </div>
            <img src="../images/two/t1.png" alt="" class="one-img"></div>
        <div class="two-items">
            <div class="cover-box">
                <div class="content-box">
                    吉祥木马
                </div>
                <img src="../images/two/t2.png" alt="" class="two-img"></div>
            <div class="cover-box">
                <div class="content-box">
                    喜马天轮
                </div>
                <img src="../images/two/t22.png" alt="" class="two-img"></div>
        </div>
        <Title>
            <template v-slot:index>
                <div class="t1">
                    <span class="index">2</span>
                    增长见识的演艺秀
                </div>
            </template>
            <template v-slot:xc>
                <div class="t2">
                    小朋友最喜欢：海豚剧场 小鸟加油 小小马戏团 ...
                </div>
            </template>
        </Title>
        <div class="cover-box">
            <div class="content-box">
                与海洋家族互动
            </div>
            <img src="../images/two/t3.png" alt="" class="one-img"></div>
        <div class="two-items">
            <div class="cover-box">
                <div class="content-box">
                    小小马戏团
                </div>
                <img src="../images/two/t4.png" alt="" class="two-img">
            </div>
            <div class="cover-box">
                <div class="content-box">
                    小鸟加油
                </div>
                <img src="../images/two/t44.png" alt="" class="two-img">
            </div>
        </div>
        <img src="../images/two/t5.png" alt="" class="one-img">
        <Title>
            <template v-slot:index>
                <div class="t1">
                    <span class="index">3</span>
                    亲手做件伴手礼
                </div>
            </template>
            <template v-slot:xc>
                <div class="t2">
                    小小百工体验坊 带你了解体验活字印刷、鲁班锁、陶艺...
                </div>
            </template>
        </Title>
        <img src="../images/two/t6.png" alt="" class="one-img">
        <div class="two-items">
            <img src="../images/two/t7.png" alt="" class="two-img">
            <img src="../images/two/t77.png" alt="" class="two-img">
        </div>
        <Title>
            <template v-slot:index>
                <div class="t1">
                    <span class="index">4</span>
                    回看秦汉王城、万园之园
                </div>
            </template>
            <template v-slot:xc>
                <div class="t2">
                    走进历史，看尽大秦王城霸气雄伟、皇家园林华丽再现
                </div>
            </template>
        </Title>
        <img src="../images/two/t8.png" alt="" class="one-img">
        <div class="two-items">
            <img src="../images/two/t9.png" alt="" class="two-img">
            <img src="../images/two/t99.png" alt="" class="two-img">
        </div>
        <img src="../images/two/r1.png" alt="" class="one-img">
        <div class="two-items">
            <img src="../images/two/r2.png" alt="" class="two-img">
            <img src="../images/two/r22.png" alt="" class="two-img">
        </div>
        <Title style="height: 26vw;">
            <template v-slot:index>
                <div class="t1">
                    <span class="index">5</span>
                    雷迪森度假庄园--亲子主题房
                </div>
            </template>
            <template v-slot:xc>
                <div class="t2">
                    地中海法式的建筑风格，与山相邻，与水相依，确 是梦想中的庄园。在茂密的森林下隐匿的一处神秘 庄园内，常常会传来孩子们银铃般的欢
                </div>
            </template>
        </Title>
        <img src="../images/two/r3.png" alt="" class="one-full-img">
        <img src="../images/two/r4.png" alt="" class="one-full-img">
        <img src="../images/two/r5.png" alt="" class="one-full-img">
        <div class="content">
            城堡卧室里的“小心机”。在鲜花点缀的桌前，嘬一口清茶，或品一品这里新鲜采摘来的果蔬，再提起墨笔抒写下这里的奇闻。宝宝可以抱着可爱的玩偶，在柔软的床上翻滚，蹦跶。
        </div>
        <img src="../images/two/r6.png" alt="" class="one-full-img">
        <div class="content">
            不出庄园，也有更多体验。室内有健身达人爱去的健身房，宝宝的
            童玩区，女王的SPA水疗，还有书吧、影视厅等活动室放松心情。
        </div>
        <div class="red-content">
            <span style="font-weight: 600;">【美食推荐】</span>加 <span style="color: #FFDE00;">168</span>元/位尽享饕餮大餐
        </div>
        <img src="../images/two/r7.png" alt="" class="one-full-img">
        <div class="content">
            睡得舒适，玩得舒畅，也要吃得痛快。奢华的海鲜自助餐，尽情释放你的胃。小龙虾、帝王蟹、生蚝等众多海鲜华丽登场，还有马卡龙、提拉米苏等多款甜品任你挑选。
        </div>
    </div>
</template>

<script>
    import Title from '../components/Title'
    export default {
        components: {
            Title,
        }
    }
</script>

<style lang="stylus" scoped>
    .two
        display flex
        flex-direction column
        align-items center
        background-color #CEAEA5
        .two-items
            display flex
            justify-content space-between
            width 92.8vw
        .content
            background-color #8E5F54
            border-radius 3vw
            line-height 1.5
            color #fff
            font-size 12px
            width 88vw
            padding 3vw 2.4vw
        .red-content
            background-color #B30808;
            color #fff;
            width 100%
            text-align center
            height 12vw
            display flex
            align-items center
            justify-content center
            margin 2vw 0
</style>